export const DEPOSIT_TAB_ID = 0
export const TRANSFER_TAB_ID = 1
